import { Fragment, useEffect } from 'react';
import { connect } from 'react-redux';
import { getDefaultStudyRoute } from 'common/permissions/studyPredicates';


const DefaultStudyRouteRedirect = (props) => {
    useEffect(() => {
        const { router, defaultStudyRoute } = props;
        router.replace(defaultStudyRoute);
    }, []);
    return (
        <Fragment>
        </Fragment>
    );
};

export default connect((state, props) => {
    const studyId = props.params.id;
    const defaultStudyRoute = getDefaultStudyRoute(state, studyId);

    return {
        defaultStudyRoute
    };
})(DefaultStudyRouteRedirect);